import React, { useState, useEffect, useRef } from 'react'
import { Box, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'

const AVAILABLE_OPERATORS = [
  { label: 'Igual o mayor', value: 'gt' },
  { label: 'Igual o menor', value: 'lt' }
]

const DEFAULT_OPERATOR = {
  label: 'Condición',
  value: ''
}

const ProcessedReactFilter = ({
  title = 'PROCESADO',
  resetWatcher,
  disabled,
  onApply
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [operatorOpen, setOperatorOpen] = useState(false)
  const [operator, setOperator] = useState(DEFAULT_OPERATOR)

  const [value, setValue] = useState('0')
  const containerRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false)
        setOperatorOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    setOperator(DEFAULT_OPERATOR)
    setValue('0')
  }, [resetWatcher])

  const numericValue = Number(value)


  const handleApply = () => {
    if (!operator.value || isNaN(numericValue) || numericValue <= 0) return

    onApply({
      operator: operator.value,
      value: numericValue
    })

    setIsOpen(false)
    setOperatorOpen(false)
  }

  const canApply = operator.value && numericValue > 0

  return (
    <div
      ref={containerRef}
      className={`react-filter-box ${disabled ? 'react-filter-disabled' : ''}`}
    >
      <div
        className="react-filter-box-clickable-zone"
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <div className="react-filter-titles">
          <div className="react-filter-title-text">
            <div className="filter-title-overflow">{title}</div>
            {canApply && <span className="text-orange react-filter-selection-count">(1)</span>}
          </div>
          <FontAwesomeIcon
            className="react-filter-title-chevron"
            icon={isOpen ? faCaretUp : faCaretDown}
          />
        </div>
      </div>

      {isOpen && (
        <div
          className={`react-filter-dropdown-box-poc box-transition ${operatorOpen ? 'expanded' : ''}`}
        >
          <Box p={2} display="flex" flexDirection="column" gap={1}>
            <Typography fontSize={12} color="#6B7280">
              Filtrar por
            </Typography>

            <Box display="flex" gap={1} alignItems="center">
              <div className="react-filter-box react-filter-operator-small">
                <div
                  className="react-filter-box-clickable-zone"
                  onClick={() => setOperatorOpen(!operatorOpen)}
                >
                  <div className="react-filter-titles">
                    <div className="react-filter-title-text">
                      <div className="filter-title-overflow">{operator.label}</div>
                    </div>
                    <FontAwesomeIcon
                      className="react-filter-title-chevron"
                      icon={operatorOpen ? faCaretUp : faCaretDown}
                    />
                  </div>
                </div>

                {operatorOpen && (
                  <div className="react-filter-dropdown-process-box">
                    {AVAILABLE_OPERATORS.map(op => (
                      <div
                        key={op.value}
                        className="react-filter-option"
                        onClick={() => {
                          setOperator(op)
                          setOperatorOpen(false)
                        }}
                      >
                        {op.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #597FA9',
                  borderRadius: '4px',
                  height: 37,
                  width: 75,
                  overflow: 'hidden',
                  mt: 0.6
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onFocus={() => {
                      if (value === '0') setValue('')
                    }}
                    onBlur={() => {
                      if (value === '') setValue('0')
                    }}
                    className="processed-percent-input"
                  />
                </Box>

                <Box
                  sx={{
                    width: '1px',
                    height: '100%',
                    backgroundColor: '#597FA9'
                  }}
                />

                <Box
                  sx={{
                    width: 23,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 15,
                    color: '#597FA9'
                  }}
                >
                  %
                </Box>
              </Box>
            </Box>

            <Box display="flex" justifyContent="flex-end" mt={1}>
              <Typography
                variant="subtitle2"
                className={`apply-filter-text ${canApply ? 'active' : 'disabled'}`}
                onClick={() => {
                  if (canApply) handleApply()
                }}
              >
                Aplicar
              </Typography>
            </Box>
          </Box>
        </div>
      )}
    </div>
  )
}

export default ProcessedReactFilter

